"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _MediaSourcesContainer = _interopRequireDefault(require("./MediaSourcesContainer"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The MediaItem model module.
 * @module model/MediaItem
 * @version 3.0
 */
var MediaItem = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>MediaItem</code>.
   * @alias module:model/MediaItem
   */
  function MediaItem() {
    _classCallCheck(this, MediaItem);
    MediaItem.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(MediaItem, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>MediaItem</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MediaItem} obj Optional instance to populate.
     * @return {module:model/MediaItem} The populated <code>MediaItem</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new MediaItem();
        if (data.hasOwnProperty('mediaSourcesContainer')) {
          obj['mediaSourcesContainer'] = _MediaSourcesContainer["default"].constructFromObject(data['mediaSourcesContainer']);
        }
        if (data.hasOwnProperty('itemLegacyId')) {
          obj['itemLegacyId'] = _ApiClient["default"].convertToType(data['itemLegacyId'], 'String');
        }
        if (data.hasOwnProperty('offlineAllowed')) {
          obj['offlineAllowed'] = _ApiClient["default"].convertToType(data['offlineAllowed'], 'Boolean');
        }
        if (data.hasOwnProperty('name')) {
          obj['name'] = _ApiClient["default"].convertToType(data['name'], 'String');
        }
        if (data.hasOwnProperty('mediaType')) {
          obj['mediaType'] = _ApiClient["default"].convertToType(data['mediaType'], 'String');
        }
        if (data.hasOwnProperty('tags')) {
          obj['tags'] = _ApiClient["default"].convertToType(data['tags'], 'String');
        }
        if (data.hasOwnProperty('description')) {
          obj['description'] = _ApiClient["default"].convertToType(data['description'], 'String');
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>MediaItem</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MediaItem</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // validate the optional field `mediaSourcesContainer`
      if (data['mediaSourcesContainer']) {
        // data not null
        _MediaSourcesContainer["default"].validateJSON(data['mediaSourcesContainer']);
      }
      // ensure the json data is a string
      if (data['itemLegacyId'] && !(typeof data['itemLegacyId'] === 'string' || data['itemLegacyId'] instanceof String)) {
        throw new Error("Expected the field `itemLegacyId` to be a primitive type in the JSON string but got " + data['itemLegacyId']);
      }
      // ensure the json data is a string
      if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
        throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
      }
      // ensure the json data is a string
      if (data['mediaType'] && !(typeof data['mediaType'] === 'string' || data['mediaType'] instanceof String)) {
        throw new Error("Expected the field `mediaType` to be a primitive type in the JSON string but got " + data['mediaType']);
      }
      // ensure the json data is a string
      if (data['tags'] && !(typeof data['tags'] === 'string' || data['tags'] instanceof String)) {
        throw new Error("Expected the field `tags` to be a primitive type in the JSON string but got " + data['tags']);
      }
      // ensure the json data is a string
      if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
        throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
      }
      return true;
    }
  }]);
}();
/**
 * @member {module:model/MediaSourcesContainer} mediaSourcesContainer
 */
MediaItem.prototype['mediaSourcesContainer'] = undefined;

/**
 * @member {String} itemLegacyId
 */
MediaItem.prototype['itemLegacyId'] = undefined;

/**
 * @member {Boolean} offlineAllowed
 */
MediaItem.prototype['offlineAllowed'] = undefined;

/**
 * @member {String} name
 */
MediaItem.prototype['name'] = undefined;

/**
 * @member {String} mediaType
 */
MediaItem.prototype['mediaType'] = undefined;

/**
 * @member {String} tags
 */
MediaItem.prototype['tags'] = undefined;

/**
 * @member {String} description
 */
MediaItem.prototype['description'] = undefined;
var _default = exports["default"] = MediaItem;